var _path, _path2, _path3, _path4, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiveOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.02319 17.5416V25.9886L4.38422 26.4085L4.74525 26.8283L11.937 26.8699L19.1288 26.9115L19.0471 26.421C19.0021 26.1513 18.9358 25.7829 18.8997 25.6026C18.8635 25.4222 18.902 24.7826 18.985 24.1812C19.4891 20.5309 22.9421 17.7553 26.5108 18.1316C27.021 18.1854 27.6237 18.27 27.8499 18.3195L28.2614 18.4097V13.829V9.24814H23.2491H18.2369V10.7542C18.2369 12.2185 18.0966 12.839 17.7655 12.839C17.6765 12.839 17.2722 12.5957 16.8672 12.2983L16.1305 11.7575L15.3731 12.2876C14.9565 12.5794 14.5236 12.7826 14.411 12.7393C14.2577 12.6805 14.1959 12.224 14.1645 10.9171L14.1224 9.17333L9.07281 9.13398L4.02319 9.09448V17.5416ZM11.2797 21.8161V22.1901L9.59363 22.2325C8.19036 22.2676 7.89292 22.2364 7.81961 22.0454C7.77128 21.9193 7.77128 21.7128 7.81961 21.5867C7.89292 21.3958 8.19036 21.3645 9.59363 21.3997L11.2797 21.442V21.8161ZM11.2797 24.0604V24.4344H9.56116C7.99795 24.4344 7.83771 24.409 7.78834 24.1531C7.70096 23.699 8.04538 23.6084 9.70869 23.6485C11.2746 23.6862 11.2797 23.6875 11.2797 24.0604Z",
    fill: "#D22730"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00979 6.59251C2.96191 4.87041 3.07009 4.53631 3.77494 4.22974C4.1454 4.0686 5.32334 4.02207 9.14938 4.01743L14.0494 4.0116V6.10805V8.20465L8.5509 8.1653L3.05243 8.1261L3.00979 6.59251Z",
    fill: "#5575C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2351 8.3503V6.17515V4L23.3103 4.04309L28.3854 4.08618L28.7714 4.44885C29.1417 4.79702 29.1572 4.87945 29.1572 6.4901C29.1572 7.88274 29.117 8.18408 28.9205 8.25949C28.7904 8.30946 26.3329 8.3503 23.4595 8.3503H18.2351Z",
    fill: "#5575C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0774 11.3429C14.9274 11.3429 14.8983 4.26071 15.0478 4.11139C15.1026 4.05648 15.6075 4.0116 16.1699 4.0116H17.1923V7.68248C17.1923 11.272 17.1858 11.3499 16.9014 11.1978C16.7413 11.112 16.5691 10.9751 16.5186 10.8933C16.3733 10.6582 16.0007 10.7185 15.5873 11.0437C15.378 11.2082 15.1486 11.3429 15.0774 11.3429Z",
    fill: "#5575C6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19157_8237",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 17,
    width: 15,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.155,
    y: 17.936,
    width: 14.0641,
    height: 14.0641,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19157_8237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3683 27.6638L29.4996 23.5325L28.6792 22.7121L25.3683 26.023L23.6981 24.3529L22.8777 25.1733L25.3683 27.6638ZM26.1887 30.8283C25.378 30.8283 24.6162 30.6743 23.9032 30.3665C23.1903 30.059 22.5701 29.6416 22.0427 29.1142C21.5153 28.5868 21.0978 27.9666 20.7904 27.2536C20.4825 26.5407 20.3286 25.7788 20.3286 24.9682C20.3286 24.1576 20.4825 23.3958 20.7904 22.6828C21.0978 21.9698 21.5153 21.3496 22.0427 20.8222C22.5701 20.2948 23.1903 19.8772 23.9032 19.5693C24.6162 19.2619 25.378 19.1082 26.1887 19.1082C26.9993 19.1082 27.7611 19.2619 28.4741 19.5693C29.1871 19.8772 29.8072 20.2948 30.3346 20.8222C30.8621 21.3496 31.2795 21.9698 31.5869 22.6828C31.8948 23.3958 32.0487 24.1576 32.0487 24.9682C32.0487 25.7788 31.8948 26.5407 31.5869 27.2536C31.2795 27.9666 30.8621 28.5868 30.3346 29.1142C29.8072 29.6416 29.1871 30.059 28.4741 30.3665C27.7611 30.6743 26.9993 30.8283 26.1887 30.8283Z",
    fill: "#5575C6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiveOrders);
export default __webpack_public_path__ + "static/media/receiveOrders.2e0e714256b8ce873ee4abef22967263.svg";
export { ForwardRef as ReactComponent };